/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import * as petrol_station from '../../appRedux/actions/petrol_station';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TankerProbe(props) {
  const [probe, setProbe] = useState(null);
  const [loading, setLoading] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    fetchProbe();
    intervalRef.current = setInterval(() => {
      fetchProbe();
    }, 120000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const fetchProbe = async () => {
    try {
      setLoading(true);
      const result = await props.fuelCarProbe();
      setProbe(result);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Alert
        variant="filled"
        icon={false}
        severity="info"
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 2,
        }}
        action={
          <Button
            onClick={fetchProbe}
            color="inherit"
            size="small"
            sx={{ alignSelf: 'center', px: 2 }}
          >
            {loading ? 'در حال به‌روزرسانی…' : 'به‌روزرسانی'}
          </Button>
        }
      >
        <Typography variant="subtitle1" sx={{ fontSize: 15 }}>
          ظرفیت تانکر سوخت‌رسان <b>{probe?.iFuelLiter || 0} لیتر</b> است.
        </Typography>
      </Alert>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  field: state.field,
  list: state.field.list,
  menu: state.common.menu,
});

const mapDispatchToProps = (dispatch) => ({
  fuelCarProbe: () => dispatch(petrol_station.fuelCarProbe()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TankerProbe);
